import React, { useMemo } from 'react';
import { Redirect, useRouteMatch } from 'react-router-dom';

import { resolveLiveQuestionType } from 'js/utils/sentiment-question';
import LongTextQuestionDetail from './LongTextQuestionDetail';

function RedirectToResults({ match }) {
  const resultsHref = match.url.replace(/\/questions\/[^/]+$/, '/results');
  return <Redirect to={resultsHref} />;
}

function getQuestionDetailComponent(question) {
  if (question == null) {
    return null;
  }

  return resolveLiveQuestionType(question) === 'long-text'
    ? LongTextQuestionDetail
    : RedirectToResults;
}

const QuestionDetail = ({ assessments, ...props }) => {
  const {
    params: { assessmentId, questionId: matchQuestionId },
  } = useRouteMatch();
  const questionId = Number(matchQuestionId);

  const { assessment, question } = useMemo(() => {
    const assessment = (assessments ?? []).find((a) => a.id === assessmentId);
    const questions =
      assessment?.question_sets.flatMap((qs) => qs.questions) ?? [];
    const question = questions.find(
      (q) => q.id === questionId || String(q.id) === String(matchQuestionId)
    );

    return { assessment, question };
  }, [assessments, questionId, assessmentId, matchQuestionId]);

  const DetailComponent = getQuestionDetailComponent(question);

  if (!assessment || !question || !DetailComponent) {
    return <RedirectToResults {...props} />;
  }

  return (
    <DetailComponent {...props} assessment={assessment} question={question} />
  );
};

export default QuestionDetail;
